import { BannerId } from '../../../typings/banners';
import { InternalTemplateId } from '../../../typings/internalBanners';

export const UPDATE_INTERNAL_BANNER_TEMPLATE_ID = 'UPDATE_INTERNAL_BANNER_TEMPLATE_ID';
export type UPDATE_INTERNAL_BANNER_TEMPLATE_ID = typeof UPDATE_INTERNAL_BANNER_TEMPLATE_ID;
export interface UpdateInternalBannerTemplateId {
    type: UPDATE_INTERNAL_BANNER_TEMPLATE_ID;
    bannerId: BannerId;
    value: InternalTemplateId;
}

export function updateInternalBannerTemplateIdAction(
    bannerId: BannerId,
    value: InternalTemplateId
): UpdateInternalBannerTemplateId {
    return {
        type: UPDATE_INTERNAL_BANNER_TEMPLATE_ID,
        bannerId,
        value
    };
}
